import { createContext, useContext, useMemo, useState } from "react";

const PurchaseInfosValueContext = createContext();
const PurchaseInfosActionsContext = createContext();

export function PurchaseInfosContextProvider({ children }) {
    const [purchaseInfos, setPurchaseInfos] = useState(null);

    const purchaseInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setPurchaseInfos(newValues);
                },
                setValue: setPurchaseInfos
            }
        },
        []
    )

    return (
        <>
            <PurchaseInfosActionsContext.Provider value={{ purchaseInfos: purchaseInfosActions }}>
                <PurchaseInfosValueContext.Provider value={{ purchaseInfos }}>
                    {children}
                </PurchaseInfosValueContext.Provider>
            </PurchaseInfosActionsContext.Provider>
        </>
    );
}

export function usePurchaseInfosValueContextHook(props) {
    const value = useContext(PurchaseInfosValueContext);

    if (value === undefined) {
        throw new Error('usePurchaseInfosValueContextHook should be used within PurchaseInfosContextProvider');
    }

    return {
        purchaseInfos: value.purchaseInfos,
    };
}

export function usePurchaseInfosActionsContextHook(props) {
    const value = useContext(PurchaseInfosActionsContext);

    if (value === undefined) {
        throw new Error('usePurchaseInfosActionsContextHook should be used within PurchaseInfosContextProvider');
    }

    return {
        purchaseInfos: {
            onSet: value.purchaseInfos.onSet,
            setValue: value.purchaseInfos.setValue
        },
    };
}